<template>
  <div class="resourceManagement" style="height: calc(100% - 10px)">
    <el-container>
      <el-aside :class="{noboder: treeData.length === 0}">
        <el-scrollbar style="height: 100%;width: auto;">
          <tree :treeData="treeData" @getResourceList="getResourceList" :functionId="queryParams.functionId" />
        </el-scrollbar>
      </el-aside>
      <el-main v-if="queryParams.functionId">
        <div style="height: 100%;">
          <!-- search -->
          <search @getResourceList="getResourceList"></search>
          <el-row class="operation-box">
            <el-button size="small" type="default" icon="el-hg-icon-detail" @click="getDetail">详情</el-button>
            <el-button size="small" type="default" icon="el-hg-icon-add" @click="add" v-permission="'0601'">新增</el-button>
            <el-button size="small" type="primary" icon="el-hg-icon-edit" @click="edit" v-permission="'0602'">修改</el-button>
            <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="delItems" v-permission="'0704'">删除</el-button>
            <el-button size="small" type="success" icon="el-hg-icon-start" @click="startUse" v-permission="'0604'">启用</el-button>
            <el-button size="small" type="warning" icon="el-hg-icon-stop" @click="stopUse" v-permission="'0605'">停用</el-button>
            <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="refresh">刷新</el-button>
          </el-row>
          <el-scrollbar style="height: calc( 100% - 80px);width: 100%;overflow-x: hidden;">
            <list :dataList.sync="aDataList" :functionType="queryParams.type" @detail="getDetail" />
          </el-scrollbar>
        </div>
      </el-main>
    </el-container>
    <div class="clear"></div>
    <add :show="bAddShow" :functionId="queryParams.functionId" :functionType="queryParams.type" @close="bAddShow = false" @refresh="refresh" />
    <edit-dialog :title.sync="title" :is-edit.sync="isEdit" :data="oActiveItem" :functionType="queryParams.type" :show="bShowEditDialog" @close="bShowEditDialog = false" @refresh="refresh" />
  </div>
</template>
<script>
import search from './search';
import tree from './tree';
import list from './list';
import add from './actions/add';
import editDialog from './actions/edit';

export default {
  name: 'resourceManagement',
  components: {
    search,
    tree,
    list,
    add,
    editDialog
  },
  data() {
    return {
      queryParams: {
        name: '',
        functionId: '',
        type: 1
      },
      aDataList: [],
      bAddShow: false,
      oActiveItem: {
        id: 0,
        code: '',
        name: '',
        operateType: '0',
        type: '',
        afterUrl: '',
        routeUrl: '',
        gateway: '',
        use: [],
        component: ''
      },
      bShowEditDialog: false,
      treeData: [],
      title: '',
      isEdit: false
    };
  },
  computed: {
    selected() {
      let ids = [];
      let resourceList = [];
      let textInfo = [];
      this.aDataList.forEach(data => {
        if (data.checked) {
          ids.push({
            value: data.id
          });
          textInfo.push(data.name);
          resourceList.push(data);
        }
      });
      return {
        ids,
        list: resourceList,
        textInfo
      };
    }
  },
  methods: {
    delItems() {
      this.deleteResource();
    },
    async deleteResource() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一个资源');
        return;
      }
      this.$confirm(`此操作将永久删除资源<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$services.postLoading({
          type: 'RESOURCEMANGEMENT',
          url: 'deleteResource',
          params: { ids: JSON.stringify(this.selected.ids) }
        }).then(res => {
          if (res.code === '000') {
            this.$toaster.ok('删除成功');
            this.refresh();
          }
          else {
            this.$toaster.error(res.msg);
          }
        });
      }).catch(() => {
      });
    },
    edit() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一个资源');
        return;
      }
      this.title = '编辑资源';
      this.isEdit = true;
      [this.oActiveItem] = JSON.parse(JSON.stringify(this.selected.list));
      this.oActiveItem.use = this.selected.list[0].use === null ? [] : this.selected.list[0].use.split(',');
      this.oActiveItem.type = this.selected.list[0].type === null || '' ? '' : this.selected.list[0].type.toString();
      this.oActiveItem.operateType = this.selected.list[0].operateType === null || '' ? '' : this.selected.list[0].operateType.toString();
      this.bShowEditDialog = true;
    },
    getDetail() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一个资源');
        return;
      }
      this.title = '资源详情';
      this.isEdit = false;
      [this.oActiveItem] = JSON.parse(JSON.stringify(this.selected.list));
      this.oActiveItem.use = this.selected.list[0].use === null ? [] : this.selected.list[0].use.split(',');
      this.oActiveItem.type = this.selected.list[0].type === null || '' ? '' : this.selected.list[0].type.toString();
      this.oActiveItem.operateType = this.selected.list[0].operateType === null || '' ? '' : this.selected.list[0].operateType.toString();
      this.bShowEditDialog = true;
    },
    add() {
      this.bAddShow = true;
    },
    async getResourceList(params) {
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
      if (this.queryParams.functionId === '') {
        this.$toaster.error('请选择功能');
        return;
      }
      const res = await this.$services.postLoading({
        type: 'RESOURCEMANGEMENT',
        url: 'getResourceList',
        params: this.queryParams
      });
      res.bean.forEach(rep => {
        rep.checked = false;
      });
      this.aDataList = res.bean;
    },
    handleCurrentChange(currentPage) {
      this.queryParams.currentPage = currentPage;
      this.getResourceList();
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize;
      this.getResourceList();
    },
    refresh() {
      this.getResourceList();
    },
    async getAllFunctionList() {
      const res = await this.$services.postLoading({
        type: 'FUNCTIONMANGEMENT',
        url: 'getFunctionList'
      });
      this.treeData = res.bean;
      if (this.treeData.length > 0) {
        if (this.treeData[0].children.length > 0) {
          this.queryParams.functionId = this.treeData[0].children[0].id;
          this.queryParams.type = this.treeData[0].children[0].type;
        }
        else {
          this.queryParams.functionId = this.treeData[0].id;
          this.queryParams.type = this.treeData[0].type;
        }
      }
      else {
        this.queryParams.functionId = '';
        this.queryParams.type = 1;
      }
      this.getResourceList();
    },

    async updateResourceStatus(state) {
      // state 0：停用，1：启用
      const res = await this.$services.postLoading({
        type: 'RESOURCEMANGEMENT',
        url: 'updateResourceStatus',
        params: {
          ids: JSON.stringify(this.selected.ids),
          state
        }
      });
      if (res.code === '000') {
        this.$message({
          type: 'success',
          message: state === 0 ? '停用成功' : '启用成功'
        });
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: state === 0 ? '停用失败' : '启用失败'
        });
      }
    },
    startUse() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一用户');
        return;
      }
      this.$confirm(`此操作将启用<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateResourceStatus(1);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消启用'
        });
      });
    },
    stopUse() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一用户');
        return;
      }
      this.$confirm(`此操作将停用<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateResourceStatus(0);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停用'
        });
      });
    }
  },
  created() {
    this.getAllFunctionList();
  }
};
</script>
<style lang="scss">
.resourceManagement {
  .operation-box{
    padding: 10px 0 10px 10px;
  }
  .el-container {
    // border: 1px solid #eee;
    // box-shadow: 0px 0px 10px #eee;
    border-radius: 5px;

    .el-aside.noboder {
      border-right: none;
    }

    .el-aside {
      width: auto !important;
      padding: 10px 30px 10px 10px;
      // border-right: 1px solid #eee;
      height: 100%;
      overflow: auto;

      .el-scrollbar {
        .el-scrollbar__wrap {
          margin: 0;
          overflow-x: hidden !important;
        }
      }
    }

    .el-main {
      padding-left: 10px;
    }
  }
}
</style>
